import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-week-selector',
  templateUrl: './week-selector.component.html',
  styleUrls: ['./week-selector.component.css']
})
export class WeekSelectorComponent implements OnInit, AfterViewInit {

  tabsDateRange: any[] = [];
  @Input() maxDate: any = moment(new Date(8640000000000000));
  @Input() hasTodayButton = true;
  @Input() showSearchButton = true;
  @Input() emitChangeAfterInit = false;
  dateFrom: any = moment();
  dateTo: any = moment();
  fromText: string;
  toText: string;
  minZoomLevel: any = "decade";
  maxZoomLevel: any = "month";
  zoomLevel: any = "month";
  intervalSelected: boolean = false;
  @Output() changeDate = new EventEmitter<any>();
  @Output() rangeSelectedIndexChanged = new EventEmitter<number>();
  todayText = this.languageService.LNG("Label.Today");
  searchText = this.languageService.LNG("Label.Search");

  constructor(private languageService: LanguageService) { }

  ngOnInit() {
    this.dateFrom = moment(this.dateFrom).startOf('isoWeek');
    this.dateTo = moment(this.dateFrom).add(4, 'weeks');//add 4 weeks to get 5 in total
    this.setDateText();
  }

  ngAfterViewInit() {
    if (this.emitChangeAfterInit) { setTimeout(() => this.setSelectedDate(), 0); }
  }

  setSelectedDate() {
    
    this.dateFrom = moment(this.dateFrom).startOf('isoWeek');
    this.dateTo = moment(this.dateTo).endOf('isoWeek');

    if (this.dateTo > this.maxDate) { this.dateTo = this.maxDate; }
    
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  prev_Click_from() {
    this.dateFrom = moment(this.dateFrom).subtract(1, 'week').startOf('isoWeek');
    //
    this.setDateText();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  next_Click_from() {
    if (this.dateTo >= this.maxDate) { return; }

    this.dateFrom = moment(this.dateTo).add(1, 'week').startOf('isoWeek');

    this.setDateText();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  prev_Click_to() {
    this.dateTo = moment(this.dateTo).subtract(1, 'week').endOf('isoWeek');
    //
    this.setDateText();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  next_Click_to() {
    if (this.dateTo >= this.maxDate) { return; }

    this.dateTo = moment(this.dateTo).add(1, 'week').endOf('isoWeek');

    this.setDateText();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  today_Click() {
    this.dateFrom = moment().startOf('isoWeek');
    this.dateTo = moment().add(4, 'weeks');//add 4 weeks to get 5 in total
    this.setSelectedDate();
    this.setDateText();
  }

  search_Click() {
    
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  fromDateChanged(e) {
    
    this.dateFrom = moment(e.value).startOf('isoWeek');
    this.setDateText();
  }

  toDateChanged(e) {
    
    this.dateTo = moment(e.value).endOf('isoWeek');
    this.setDateText();
  }

  setDateText() {
    if (this.dateFrom > this.maxDate) 
    {
      this.dateFrom = this.maxDate; 
    }
    if (this.dateTo > this.maxDate) 
    {
      this.dateTo = this.maxDate; 
    }

    let fromWeeknumber = moment(this.dateFrom).isoWeek();
    let fromWeekyear = moment(this.dateFrom).isoWeekYear();
    this.fromText  = fromWeeknumber + "." + fromWeekyear;

    let toWeeknumber = moment(this.dateTo).isoWeek();
    let toWeekyear = moment(this.dateTo).isoWeekYear();
    this.toText  = toWeeknumber + "." + toWeekyear;
  }

  @Input()
  set selectedDate(date) {

    this.dateFrom = moment(date).startOf('isoWeek');
    this.dateTo = moment(this.dateFrom).add(35, 'days');//5 weeks
    this.setDateText();
  }

}
